export default __webpack_public_path__ + "static/media/SZYBKOSC.cf85d271.png";